<template>
  <div>
    <!-- 头部-->
    <NavTop style="width: 100%;"></Navtop>
    <div class="talents-container">
      <div class="banner" style="height: 300px;">
        <swiper class="swiper" style="height: 300px;" :options="swiperOptions">
          <swiper-slide class="swiper_img" style="height: 300px;" v-for="(slide, index) in slides" :key="index">
            <img style="height: 300px;" :src="slide.url" alt="Slide Image">
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <!--  -->
      <div class="container">
        <div class="detail-breadcrumb">
          <p>{{ detailData.title }}</p>
          <div class="breadcrumb">
            <span @click="routerpush">首页</span>
            <span @click="clickRenCai">人才培养</span>
            <span style="font-size: 14px">{{ bigTitle }}</span>
          </div>
        </div>
        <div class="detail-shadow"></div>
        <div v-if="detailData.introduce" class="ql-editor" v-html="detailData.introduce"></div>
        <div v-if="detailData.content" class="ql-editor" v-html="detailData.content"></div>
        <el-link class="ql-editor" v-if="detailData.attachment" :href="detailData.attachment" target="_blank"
                 type="primary">附件
        </el-link>
      </div>
    </div>
  </div>
</template>

<script>
import home from '../../../api/home.js'
import {getBanner} from '@/api/homeIndex.js'

export default {
  data () {
    return {
      // 大标题
      bigTitle:'',
      // 数据
      detailData: {},
      bannerUrl: [],
      // 轮播
      swiperOptions: {
        pagination: {el: '.swiper-pagination', clickable: true},
        navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
        loop: true,
        autoplay: {
          delay: 10000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        speed: 10000
      },
      slides: [],
    }
  },
  created () {
    console.log(this.$route.params.id, 'llllll')
    this.getDetail(this.$route.params.id)
    this.getBannerList()
    this.getTabBar(this.$route.params.id)
  },
  methods: {
    /**
     * 获取导航
     * */
    getTabBar (id) {
      home.getTabBarOne({id})
        .then(res => {
          this.bigTitle = res.data.name
          console.log(res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * 获取轮播图列表
     */
    getBannerList () {
      // 获取首页轮播图
      getBanner({bannerPath: '/talents/detail'}).then(res => {
        this.slides = res.rows
        console.log(this.slides)
      })
    },
    // 点击人才培养
    clickRenCai () {
      this.$router.push({path: `/talents/5/25`})
    },
    routerpush () {
      this.$router.push({path: `/`})
    },
    // 获取文章详情
    async getDetail (id) {
      try {
        const res = await home.getDetail({id})
        if (res.code == 200) {
          this.detailData = res.data
        }
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.talents-container {
  width: 100%;

  .banner {
    width: 100%;
    height: 300px !important;

    img {
      width: 100%;
      height: 300px !important;
    }
  }

  .container {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 80px !important;

    .detail-breadcrumb {
      margin: 20px 0;
      display: flex;
      justify-content: space-between;
      cursor: pointer;

      p {
        font-size: 16px;
        color: #666;
        display: flex;
        align-items: center;
      }

      .breadcrumb {
        display: flex;
        justify-content: end;

        span {
          &:nth-child(1) {
            padding: 0px 15px 0px 0;
            padding: 0px 15px 0px 0;
            font-size: 14px;
            color: #666;
            display: flex;
            justify-content: end;
            background: url(../../../assets/images/read_arrow.png) no-repeat;
            background-position: right;
            background-position-y: 2px;
            background-size: 14px;
            margin-right: 2px;
          }

          &:nth-child(2) {
            padding: 0px 15px 0px 0;
            font-size: 14px;
            color: #666;
            display: flex;
            justify-content: end;
            background: url(../../../assets/images/read_arrow.png) no-repeat;
            background-position: right;
            background-position-y: 2px;
            background-size: 14px;
            margin-right: 2px;
          }

          &:nth-child(3) {
            color: #9E070E;
            background-image: none;
            margin-right: 0;
            padding-right: 0;
          }
        }
      }
    }

    .detail-shadow {
      width: 1200px;
      height: 14px;
      background: linear-gradient(180deg, #E6E6E6, #FFFFFF);
      margin-top: -1px;
    }
  }
}
</style>
<style lang="less">
.swiper {
  width: 100%;
  height: 300px !important;

  .swiper_img {
    height: 300px !important;
    cursor: pointer;

    img {
      width: 100%;
      height: 300px !important;
    }
  }
}

.swiper-pagination {
  /* 未选中时的分页器子弹样式 */

  .swiper-pagination-bullet {
    background-color: #000 !important; /* 未选中时的背景色 */
    width: 8px;
    height: 8px;
    opacity: 0.3 !important;
    //transition: background-color 0.3s, transform 0.3s !important;
  }

  /* 选中时的分页器子弹样式 */

  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: #8D080E !important; /* 选中时的背景色 */
    width: 15px !important; /* 选中时的宽度 */
    height: 8px;
    opacity: 1 !important;
    border-radius: 5px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Talents/detail/detail.vue